import {Component, ViewChild} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {DynamicFormComponent} from 'app/core-ui/dynamic-form/containers/dynamic-form/dynamic-form.component';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {throwError} from 'rxjs';
import {CreditnotesClientBatchService} from './creditnotesClientBatch.service';

@Component({
  selector: 'creditnotesClientBatch-grid',
  templateUrl: './creditnotesClientBatch.component.html',
  providers: [CreditnotesClientBatchService],
})
export class CreditnotesClientBatchComponent extends BaseGridNoCookieComponent<CreditnotesClientBatchService> {
  @ViewChild(DynamicFormComponent)
  public form: DynamicFormComponent;

  @ViewChild('confirmModal')
  public confirmModal: ModalDirective;
  @ViewChild('rejectModal')
  public rejectModal: ModalDirective;

  public submiting: boolean = false;

  constructor(
    public gridService: CreditnotesClientBatchService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(securityService, logger, visualsService, gridService, 'creditnotesClientBatch');

    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.getValidationMessages();
      },
    });

    this.checkboxPK = 'batchId';
  }

  getCheckboxCallback() {
    this.checkboxPKArray = [];
    this.checkboxPKArrayFull = [];
    this.gridService.getPKs(this.dataCountParams()).subscribe({
      next: (data) => {
        this.checkboxPKArrayFull = data;
      },
      error: (error) => {
        return throwError(() => new Error(error));
      },
    });
  }

  //Grid Search Form Modal Handler
  handleModalOutput(event: any) {
    if (event.modalname == 'clientModal') {
      this.form.setValue('clientId', event.value.clntId);
    }
  }

  public confirmApprove() {
    this.submiting = true;
    this.gridService.approve(this.checkboxPKArray).subscribe({
      next: (data) => {
        console.log(data);
        // if(data._body == 'OK'){
        //     LogService.emitAlert({
        //         type: 'success',
        //         body: this.visuals[data._body]
        //     });
        //     this.submiting = false;
        // }else {
        //     LogService.emitAlert({
        //         type: 'error',
        //         body: this.visuals[data._body] ? this.visuals[data._body] : data._body
        //     });
        //     this.submiting = false;
        // }
        this.confirmModal.hide();
        this.submiting = false;
        this.search();
      },
      error: (error) => {
        this.submiting = false;
        this.confirmModal.hide();
        this.search();
        return throwError(() => new Error(error));
      },
    });
  }
  public confirmReject() {
    this.submiting = true;
    this.gridService.reject(this.checkboxPKArray).subscribe({
      next: (data) => {
        console.log(data);
        // if(data._body == 'OK'){
        //     LogService.emitAlert({
        //         type: 'success',
        //         body: this.visuals[data._body]
        //     });
        //     this.submiting = false;
        // }else {
        //     LogService.emitAlert({
        //         type: 'error',
        //         body: this.visuals[data._body] ? this.visuals[data._body] : data._body
        //     });
        //     this.submiting = false;
        // }
        this.rejectModal.hide();
        this.submiting = false;
        this.search();
      },
      error: (error) => {
        this.submiting = false;
        this.rejectModal.hide();
        this.search();
        return throwError(() => new Error(error));
      },
    });
  }

  public initiateApprove(params) {
    this.confirmModal.show();
  }
  public initiateReject(params) {
    this.rejectModal.show();
  }
}
